import React, { useState } from "react"
import { useAuth } from "../../../../auth"
import { useIntl } from "react-intl"
import * as Yup from "yup"
import { API_GET_PAYS_INDICATIFS_TEL_URL, API_GET_PAYS_URL, API_GET_VILLES_FRANCE_URL, CONST_DEFAULT_TOAST_OPTIONS, CONST_PAYS_ID_FRANCE } from "../../../../../constants"
import { useFormik } from "formik"
import { ProfilDetailsEspaceConsultantSalarieModel, ProfilDetailsEspaceConsultantSalarieSchemaModel } from "../../../core/_models"
import MySelectGetAllDataFromServer from "../../../../../utils/fields/MySelectGetAllDataFromServer"
import MyInptuMaskField from "../../../../../utils/fields/MyInputMaskField"
import MySelectSearchDataFromServer from "../../../../../utils/fields/MySelectSearchDataFromServer"
import { removePhotoProfil, setInfoPerso, setPhotoProfil } from "../../../core/_requests"
import { toast } from "react-toastify"
import { AxiosError, AxiosResponse } from "axios"
import { getCodePostalOfVille } from "../../../../auth/core/_requests"
import { toAbsoluteUrl } from "../../../../../../_metronic/helpers"
import { getThumbnailDriveUrl } from "../../../../../helpers/helper-global"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"

const CompteInfoPersoEditConsultantSalarie = ({ onSubmitCallback }: IPropsModel) => {
     const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
     const [loadingCodePostal, setLoadingCodePostal] = useState<boolean>(false)
     const { currentUser, setCurrentUser } = useAuth()
     const intl = useIntl()
     const MySwal = withReactContent(Swal)

     const profileDetailsSchema = Yup.object().shape({
          telIndicatifId: Yup.number().label("Indicatif téléphonique").required("L'indicatif est requis"),
          tel: Yup.string().required("Le tél. est requis"),
          paysResidenceId: Yup.number().required("Ce champ est requis"),
          villeResidenceHorsFrance: Yup.string().when("paysResidenceId", {
               is: paysResidenceId => {
                    return paysResidenceId !== CONST_PAYS_ID_FRANCE
               },
               then: schema => schema.required("Ce champ est requis"),
          }),
          villeResidenceFranceId: Yup.number().when("paysResidenceId", {
               is: CONST_PAYS_ID_FRANCE,
               then: schema => schema.required("Ce champ est requis").nullable(),
          }),
          adresseResidence: Yup.string().required("Ce champ est requis."),
          codePostalResidence: Yup.string().required("Ce champ est requis."),
          numSecuriteSociale: Yup.string().required("Ce champ est requis."),
          personneToContacterEnCasUrgenceNom: Yup.string(),
          personneToContacterEnCasUrgencePrenom: Yup.string(),
          personneToContacterEnCasUrgenceTelIndicatifId: Yup.number().nullable(),
          personneToContacterEnCasUrgenceTel: Yup.string(),
     })

     const formik = useFormik<ProfilDetailsEspaceConsultantSalarieSchemaModel>({
          initialValues: {
               telIndicatifId: currentUser?.consultant?.consultant?.telProPays?.id,
               tel: currentUser?.consultant?.consultant?.telPro,
               paysResidenceId: currentUser?.consultant?.consultant?.domicilePays?.id,
               villeResidenceHorsFrance: currentUser?.consultant?.consultant?.domicileVille || "",
               villeResidenceFranceId: currentUser?.consultant?.consultant?.domocileVilleFrance?.id,
               adresseResidence: currentUser?.consultant?.consultant?.domicileAdresse || "",
               codePostalResidence: currentUser?.consultant?.consultant?.domicileCodePostal || "",
               numSecuriteSociale: currentUser?.consultant?.consultant?.numeroSecuriteSociale || "",
               personneToContacterEnCasUrgenceNom: currentUser?.consultant?.consultant?.contactUrgenceNom || "",
               personneToContacterEnCasUrgencePrenom: currentUser?.consultant?.consultant?.contactUrgencePrenom || "",
               personneToContacterEnCasUrgenceTelIndicatifId: currentUser?.consultant?.consultant?.contactUrgenceTelPays?.id,
               personneToContacterEnCasUrgenceTel: currentUser?.consultant?.consultant?.contactUrgenceTel || "",
          },
          validationSchema: profileDetailsSchema,
          onSubmit: async (values, { setStatus }) => {
               setIsSubmitting(true)
               setStatus(false)

               const details: ProfilDetailsEspaceConsultantSalarieModel = {}
               if (values.telIndicatifId) details.telIndicatifId = values.telIndicatifId
               if (values.tel) details.tel = values.tel
               if (values.numSecuriteSociale) details.numSecuriteSociale = values.numSecuriteSociale
               if (values.adresseResidence) details.adresseResidence = values.adresseResidence
               if (values.paysResidenceId) details.paysResidenceId = values.paysResidenceId
               if (values.paysResidenceId === CONST_PAYS_ID_FRANCE && values.villeResidenceFranceId) details.villeResidenceFranceId = values.villeResidenceFranceId
               if (values.paysResidenceId !== CONST_PAYS_ID_FRANCE && values.villeResidenceHorsFrance) details.villeResidenceHorsFrance = values.villeResidenceHorsFrance
               if (values.codePostalResidence) details.codePostalResidence = values.codePostalResidence
               if (values.personneToContacterEnCasUrgenceNom) details.personneToContacterEnCasUrgenceNom = values.personneToContacterEnCasUrgenceNom
               if (values.personneToContacterEnCasUrgencePrenom) details.personneToContacterEnCasUrgencePrenom = values.personneToContacterEnCasUrgencePrenom
               if (values.personneToContacterEnCasUrgenceTelIndicatifId)
                    details.personneToContacterEnCasUrgenceTelIndicatifId = values.personneToContacterEnCasUrgenceTelIndicatifId
               if (values.personneToContacterEnCasUrgenceTel) details.personneToContacterEnCasUrgenceTel = values.personneToContacterEnCasUrgenceTel

               setInfoPerso(details)
                    .then(r => {
                         setCurrentUser(r.data)
                         toast.success("Vos modifications ont bien été prises en compte.", CONST_DEFAULT_TOAST_OPTIONS)
                         if (onSubmitCallback) onSubmitCallback()
                    })
                    .catch((e: AxiosError) => {
                         setStatus(e.response?.data?.detail ? e.response.data.detail : intl.formatMessage({ id: "FORM.STATUS.UNEXPECTED_ERROR_MESSAGE" }))
                    })
                    .finally(() => {
                         setIsSubmitting(false)
                    })
          },
     })

     function getCodePostalAccordingToSelectedVilleResidence(ville_id: number) {
          setLoadingCodePostal(true)
          getCodePostalOfVille(ville_id).then((r: AxiosResponse) => {
               formik.setFieldValue("codePostalResidence", r.data.codePostal)
               setLoadingCodePostal(false)
          })
     }

     function handleSetPhotoProfil(e) {
          const fileBinary = e.target.files[0]

          if (fileBinary) {
               toast.info(currentUser?.user?.avatarGoogleDriveId ? "Changement de votre avatar en cours ..." : "Ajout de votre avatar en cours ...", { autoClose: false })
               setPhotoProfil(fileBinary)
                    .then(r => {
                         setCurrentUser(prev => (prev ? { ...prev, user: { ...prev.user, avatarGoogleDriveId: r.data.id } } : prev))
                         toast.dismiss()
                         toast.success("Votre nouveau avatar a bien été pris en compte.")
                    })
                    .catch(e => {
                         toast.dismiss()
                         toast.error(e.response?.data?.detail ? e.response.data.detail : intl.formatMessage({ id: "FORM.STATUS.UNEXPECTED_ERROR_MESSAGE" }))
                    })
          }
     }

     function handleRemovePhotoProfil() {
          MySwal.fire({
               icon: "warning",
               text: `Êtes-vous sûr de vouloir supprimer votre avatar?`,
               showCancelButton: true,
               confirmButtonText: "Oui",
               cancelButtonText: "Annuler",
               showLoaderOnConfirm: true,
               preConfirm: async () => {
                    return removePhotoProfil()
                         .then(() => {
                              setCurrentUser(prev => (prev ? { ...prev, user: { ...prev.user, avatarGoogleDriveId: null } } : prev))
                              toast.dismiss()
                              toast.success("Votre avatar a bien été supprimé ...")
                         })
                         .catch((e: AxiosError) => {
                              toast.dismiss()
                              toast.error(e.response?.data?.detail ? e.response.data.detail : intl.formatMessage({ id: "FORM.STATUS.UNEXPECTED_ERROR_MESSAGE" }))
                         })
               },
               allowOutsideClick: () => !Swal.isLoading(),
          }).then()
     }

     return (
          <form onSubmit={formik.handleSubmit} noValidate className="form">
               {formik.status && (
                    <div className="alert alert-danger">
                         <div className="alert-text font-weight-bold">{formik.status}</div>
                    </div>
               )}

               <div className="card-body p-9">
                    <div className="row mb-6">
                         <label className="col-lg-4 col-form-label fw-bold fs-6">Avatar</label>
                         <div className="col-lg-8">
                              <div
                                   className="image-input image-input-outline"
                                   data-kt-image-input="true"
                                   style={{ backgroundImage: `url(${toAbsoluteUrl("/media/avatars/blank.png")})` }}
                              >
                                   <div
                                        className="image-input-wrapper w-125px h-125px"
                                        style={{
                                             backgroundImage: `url(${
                                                  currentUser?.user?.avatarGoogleDriveId
                                                       ? getThumbnailDriveUrl(currentUser.user.avatarGoogleDriveId)
                                                       : toAbsoluteUrl("/media/avatars/blank.png")
                                             })`,
                                        }}
                                   ></div>

                                   <label
                                        className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                                        data-kt-image-input-action="change"
                                        data-bs-original-title="Change avatar"
                                   >
                                        <i className="bi bi-pencil-fill fs-7"></i>
                                        <input type="file" name="avatar" accept=".png, .jpg, .jpeg" onChange={e => handleSetPhotoProfil(e)} />
                                   </label>

                                   {currentUser?.user?.avatarGoogleDriveId && (
                                        <span
                                             className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                                             data-kt-image-input-action="remove"
                                             data-bs-original-title="Remove avatar"
                                             onClick={() => handleRemovePhotoProfil()}
                                        >
                                             <i className="bi bi-x fs-2"></i>
                                        </span>
                                   )}
                              </div>
                         </div>
                    </div>

                    <div className="pb-6">
                         {/*Tél*/}
                         <div className="row pb-4">
                              <label className="col-lg-4 col-form-label fw-bold fs-6 required">Téléphone</label>

                              <div className="col-lg-8">
                                   <div className="row">
                                        <div className="col-lg-6 fv-row mb-lg-0 mb-3">
                                             <MySelectGetAllDataFromServer
                                                  url={API_GET_PAYS_INDICATIFS_TEL_URL}
                                                  name={"telIndicatifId"}
                                                  value={formik.values.telIndicatifId}
                                                  defaultOptions={
                                                       currentUser?.consultant?.consultant?.telProPays
                                                            ? [
                                                                   {
                                                                        label: currentUser?.consultant?.consultant?.telProPays?.phoneCodeWithPlusPrefixAndCountry,
                                                                        value: currentUser?.consultant?.consultant?.telProPays?.id,
                                                                   },
                                                              ]
                                                            : []
                                                  }
                                                  placeholder={"Choisissez un indicatif"}
                                                  onChange={val => formik.setFieldValue("telIndicatifId", val)}
                                             />
                                             {formik.errors.telIndicatifId && (
                                                  <div className="fv-plugins-message-container">
                                                       <div className="fv-help-block">{formik.errors.telIndicatifId}</div>
                                                  </div>
                                             )}
                                        </div>

                                        <div className="col-lg-6 fv-row">
                                             <MyInptuMaskField
                                                  name={"tel"}
                                                  mask={"99 999999999999999999"}
                                                  value={formik.values.tel}
                                                  placeholder={"N° de téléphone"}
                                                  inputMode={"numeric"}
                                                  onChange={e => formik.setFieldValue("tel", e.target.value)}
                                                  isInvalid={!!formik.errors.tel}
                                             />
                                             {formik.touched.tel && formik.errors.tel && (
                                                  <div className="fv-plugins-message-container">
                                                       <div className="fv-help-block">{formik.errors.tel}</div>
                                                  </div>
                                             )}
                                        </div>
                                   </div>
                              </div>
                         </div>

                         {/*N° SS*/}
                         <div className="row">
                              <label className="col-lg-4 col-form-label fw-bold fs-6 required">Numéro de sécurité sociale</label>

                              <div className="col-lg-8 fv-row">
                                   <MyInptuMaskField
                                        name={"numSecuriteSociale"}
                                        mask={"9 99 99 99 999 999 99"}
                                        value={formik.values.numSecuriteSociale}
                                        placeholder={"N° de sécurité sociale"}
                                        inputMode={"numeric"}
                                        onChange={e => formik.setFieldValue("numSecuriteSociale", e.target.value)}
                                        isInvalid={!!formik.errors.numSecuriteSociale}
                                   />
                                   {formik.touched.numSecuriteSociale && formik.errors.numSecuriteSociale && (
                                        <div className="fv-plugins-message-container">
                                             <div className="fv-help-block">{formik.errors.numSecuriteSociale}</div>
                                        </div>
                                   )}
                              </div>
                         </div>
                    </div>

                    {/*RESIDENCE*/}
                    <div className={"pb-6"}>
                         <h3 className={"mt-8 mb-4"}>Résidence</h3>
                         <div className="separator separator-dashed mb-6" />

                         {/*Adresse de résidence*/}
                         <div className="row mb-6">
                              <label className="col-lg-4 col-form-label fw-bold fs-6 required">
                                   <span>Adresse de résidence</span>
                              </label>

                              <div className="col-lg-8 fv-row">
                                   <input
                                        type="text"
                                        className="form-control form-control-lg mb-3 mb-lg-0"
                                        placeholder="Adresse de résidence"
                                        {...formik.getFieldProps("adresseResidence")}
                                        autoComplete={"off"}
                                   />
                                   {formik.errors.adresseResidence && (
                                        <div className="fv-plugins-message-container">
                                             <div className="fv-help-block">{formik.errors.adresseResidence}</div>
                                        </div>
                                   )}
                              </div>
                         </div>

                         {/*Pays de résidence*/}
                         <div className="row mb-6">
                              <label className="col-lg-4 col-form-label fw-bold fs-6 required">
                                   <span>Pays de résidence</span>
                              </label>

                              <div className="col-lg-8 fv-row">
                                   <MySelectGetAllDataFromServer
                                        url={API_GET_PAYS_URL}
                                        name={"paysResidenceId"}
                                        value={formik.values.paysResidenceId}
                                        defaultOptions={
                                             currentUser?.consultant?.consultant?.domicilePays
                                                  ? [
                                                         {
                                                              label: currentUser?.consultant?.consultant?.domicilePays?.nomFr,
                                                              value: currentUser?.consultant?.consultant?.domicilePays?.id,
                                                         },
                                                    ]
                                                  : []
                                        }
                                        placeholder={"Choisissez un pays"}
                                        onChange={val => formik.setFieldValue("paysResidenceId", val)}
                                   />
                                   {formik.touched.paysResidenceId && formik.errors.paysResidenceId && (
                                        <div className="fv-plugins-message-container">
                                             <div className="fv-help-block">{formik.errors.paysResidenceId}</div>
                                        </div>
                                   )}
                              </div>
                         </div>

                         {/*Ville & code postal*/}
                         {formik.values.paysResidenceId && (
                              <div className="row mb-6">
                                   <label className="col-lg-4 col-form-label required fw-bold fs-6">Ville et code postal</label>

                                   <div className="col-lg-8">
                                        <div className="row">
                                             <div className="col-lg-6 mb-lg-0 mb-3 fv-row">
                                                  {formik.values.paysResidenceId === CONST_PAYS_ID_FRANCE ? (
                                                       <>
                                                            <MySelectSearchDataFromServer
                                                                 url={API_GET_VILLES_FRANCE_URL}
                                                                 name={"villeResidenceFranceId"}
                                                                 defaultOptions={
                                                                      currentUser?.consultant?.consultant?.domocileVilleFrance
                                                                           ? [
                                                                                  {
                                                                                       value: currentUser?.consultant?.consultant?.domocileVilleFrance?.id,
                                                                                       label: currentUser?.consultant?.consultant?.domocileVilleFrance?.nom,
                                                                                  },
                                                                             ]
                                                                           : []
                                                                 }
                                                                 value={formik.values.villeResidenceFranceId}
                                                                 placeholder={"Choisissez une ville"}
                                                                 method={"GET"}
                                                                 onChange={val => {
                                                                      formik.setFieldValue("villeResidenceFranceId", val)
                                                                      console.log(val)
                                                                      getCodePostalAccordingToSelectedVilleResidence(Number(val))
                                                                 }}
                                                                 minimumLengthSearch={1}
                                                            />
                                                            {formik.touched.villeResidenceFranceId && formik.errors.villeResidenceFranceId && (
                                                                 <div className="fv-plugins-message-container">
                                                                      <div className="fv-help-block">{formik.errors.villeResidenceFranceId}</div>
                                                                 </div>
                                                            )}
                                                       </>
                                                  ) : (
                                                       <>
                                                            <input
                                                                 type="text"
                                                                 className="form-control form-control-lg mb-3 mb-lg-0"
                                                                 placeholder="Ville de résidence"
                                                                 {...formik.getFieldProps("villeResidenceHorsFrance")}
                                                                 autoComplete={"off"}
                                                            />
                                                            {formik.errors.villeResidenceHorsFrance && (
                                                                 <div className="fv-plugins-message-container">
                                                                      <div className="fv-help-block">{formik.errors.villeResidenceHorsFrance}</div>
                                                                 </div>
                                                            )}
                                                       </>
                                                  )}
                                             </div>

                                             <div className="col-lg-6 fv-row">
                                                  <input
                                                       type="text"
                                                       className="form-control form-control-lg mb-3 mb-lg-0"
                                                       placeholder="Code postal"
                                                       inputMode={"numeric"}
                                                       disabled={loadingCodePostal}
                                                       {...formik.getFieldProps("codePostalResidence")}
                                                       autoComplete={"off"}
                                                  />
                                                  {formik.errors.codePostalResidence && (
                                                       <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{formik.errors.codePostalResidence}</div>
                                                       </div>
                                                  )}
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         )}
                    </div>

                    {/*Personne à contacter en cas d'urgence*/}
                    <div className={"pb-8"}>
                         <h3 className={"mt-8 mb-4"}>Personne à contacter en cas d'urgence</h3>
                         <div className="separator separator-dashed mb-6" />

                         {/*Nom & prénom*/}
                         <div className="row mb-6">
                              <label className="col-lg-4 col-form-label fw-bold fs-6">Prénom NOM</label>

                              <div className="col-lg-8">
                                   <div className="row">
                                        <div className="col-lg-6 fv-row">
                                             <input
                                                  type="text"
                                                  className="form-control form-control-lg mb-3 mb-lg-0"
                                                  placeholder="Prénom"
                                                  {...formik.getFieldProps("personneToContacterEnCasUrgencePrenom")}
                                             />
                                             {formik.touched.personneToContacterEnCasUrgencePrenom && formik.errors.personneToContacterEnCasUrgencePrenom && (
                                                  <div className="fv-plugins-message-container">
                                                       <div className="fv-help-block">{formik.errors.personneToContacterEnCasUrgencePrenom}</div>
                                                  </div>
                                             )}
                                        </div>

                                        <div className="col-lg-6 fv-row">
                                             <input
                                                  type="text"
                                                  className="form-control form-control-lg "
                                                  placeholder="NOM"
                                                  {...formik.getFieldProps("personneToContacterEnCasUrgenceNom")}
                                             />
                                             {formik.touched.personneToContacterEnCasUrgenceNom && formik.errors.personneToContacterEnCasUrgenceNom && (
                                                  <div className="fv-plugins-message-container">
                                                       <div className="fv-help-block">{formik.errors.personneToContacterEnCasUrgenceNom}</div>
                                                  </div>
                                             )}
                                        </div>
                                   </div>
                              </div>
                         </div>

                         {/*Tél*/}
                         <div className="row pb-4">
                              <label className="col-lg-4 col-form-label fw-bold fs-6">Téléphone</label>

                              <div className="col-lg-8">
                                   <div className="row">
                                        <div className="col-lg-6 fv-row mb-lg-0 mb-3">
                                             <MySelectGetAllDataFromServer
                                                  url={API_GET_PAYS_INDICATIFS_TEL_URL}
                                                  name={"personneToContacterEnCasUrgenceTelIndicatifId"}
                                                  value={formik.values.personneToContacterEnCasUrgenceTelIndicatifId}
                                                  defaultOptions={
                                                       currentUser?.consultant?.consultant?.contactUrgenceTelPays
                                                            ? [
                                                                   {
                                                                        label: currentUser?.consultant?.consultant?.contactUrgenceTelPays?.phoneCodeWithPlusPrefixAndCountry,
                                                                        value: currentUser?.consultant?.consultant?.contactUrgenceTelPays?.id,
                                                                   },
                                                              ]
                                                            : []
                                                  }
                                                  placeholder={"Choisissez un indicatif"}
                                                  onChange={val => formik.setFieldValue("personneToContacterEnCasUrgenceTelIndicatifId", val)}
                                             />
                                             {formik.errors.personneToContacterEnCasUrgenceTelIndicatifId && (
                                                  <div className="fv-plugins-message-container">
                                                       <div className="fv-help-block">{formik.errors.personneToContacterEnCasUrgenceTelIndicatifId}</div>
                                                  </div>
                                             )}
                                        </div>

                                        <div className="col-lg-6 fv-row">
                                             <MyInptuMaskField
                                                  name={"personneToContacterEnCasUrgenceTel"}
                                                  mask={"99 999999999999999999"}
                                                  value={formik.values.personneToContacterEnCasUrgenceTel}
                                                  placeholder={"N° de téléphone"}
                                                  inputMode={"numeric"}
                                                  onChange={e => formik.setFieldValue("personneToContacterEnCasUrgenceTel", e.target.value)}
                                                  isInvalid={!!formik.errors.personneToContacterEnCasUrgenceTel}
                                             />
                                             {formik.touched.personneToContacterEnCasUrgenceTel && formik.errors.personneToContacterEnCasUrgenceTel && (
                                                  <div className="fv-plugins-message-container">
                                                       <div className="fv-help-block">{formik.errors.personneToContacterEnCasUrgenceTel}</div>
                                                  </div>
                                             )}
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>

                    <div className="card-footer d-flex justify-content-lg-end justify-content-center py-6 px-9">
                         <button type="submit" className="btn btn-sm btn-primary" disabled={isSubmitting}>
                              {!isSubmitting && "Enregister mes modifications"}
                              {isSubmitting && (
                                   <span className="indicator-progress" style={{ display: "block" }}>
                                        Veuillez patienter... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                   </span>
                              )}
                         </button>
                    </div>
               </div>
          </form>
     )
}

interface IPropsModel {
     onSubmitCallback?: () => void
}

export default CompteInfoPersoEditConsultantSalarie
